import {
  GetClassByClassId,
  GetTeacherInformation,
  GetSchoolDataBySchoolId,
} from "../../actions/teacherQueries";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import TeacherAdmin from "../../components/Teacher/Tabs/TeacherAdmin";
import TeacherResultOverview from "../../components/Teacher/Tabs/TeacherResultOverview";
import TeacherDocuments from "../../components/Teacher/Tabs/TeacherDocuments";
import TeacherCourses from "../../components/Teacher/Tabs/TeacherCourses";
import TeacherChat from "../../components/Teacher/Tabs/TeacherChat";
import { CCard, CRow, CCol, CCardBody } from "@coreui/react";
import TabNavSelector from "../../components/Teacher/Tabs/TabNavSelector";
import APL from "../../components/APL/APL";
import { useSelector } from "react-redux";

export default function TeacherClass(props) {
  const classData = GetClassByClassId(props.match.params.classId);
  const teacherInfo = GetTeacherInformation();
  const schoolInfo = GetSchoolDataBySchoolId(
    !teacherInfo.isLoading ? teacherInfo.data.customer.id : null
  );

  const tab = useSelector((state) => state.teacherTabNavReducer);

  if (
    classData.isLoading ||
    teacherInfo.isLoading ||
    schoolInfo === null ||
    schoolInfo.isLoading
  ) {
    return <Pacmanloader />;
  }

  const renderTab = () => {
    switch (tab.tab) {
      case 1:
        return (
          <TeacherAdmin
            level="Class"
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
            classData={classData}
          />
        );
      case 2:
        return (
          <TeacherCourses
            key={props.match.params.classId}
            level="Class"
            classId={classData.data.id}
            objId={"class" + props.match.params.classId}
            teacherInfo={teacherInfo}
            displayDocuments={true}
          />
        );
      case 3:
        return (
          <TeacherResultOverview level="Class" classData={classData.data} />
        );

      case 5:
        return (
          <TeacherDocuments
            level="Class"
            classId={classData.data.id}
            teacherInfo={teacherInfo}
          />
        );
      case 6:
        return <TeacherChat level="Class" />;
      case 7:
        return (
          <APL
            level="Class"
            students={classData.data.students}
            levelName={classData.data.name}
            objId={classData.data.id}
            schoolId={teacherInfo.data.customer.id}
            programId={props.match.params.programId}
            teacherInfo={teacherInfo}
          />
        );
      default:
        return (
          <TeacherAdmin
            level="Class"
            teacherInfo={teacherInfo}
            schoolInfo={schoolInfo}
            objName={classData.data.name}
            classData={classData}
          />
        );
    }
  };

  return (
    <div className="teacher-container animated fadeIn">
      <CRow>
        <CCol lg={12}>
          <CCard>
            <TabNavSelector level="class" objId={props.match.params.classId} />
            <CCardBody className="responsive-card">{renderTab()}</CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  );
}
